import * as React from 'react';
import * as Logos from '@dropbox/dig-logos';
/** Current structure doesn't allow for direct import of `src` (logo assets only) without targeting a build
 * output type, which isn't ideal when building for both esm and cjs. So we pull WormarkLogo
 * and do nothing with it so that the logo asset assignment is aligned with the type assignment. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { GlyphLogo, WordmarkLogo: _WordmarkLogo, ...rest } = Logos;
export const RowIcon = ({ item }) => {
    if (item.iconTag) {
        const logo = rest[`${item.iconTag}Glyph`];
        if (logo) {
            return React.createElement(GlyphLogo, { size: 40, src: logo, className: "dpc-Waffle-row-logo" });
        }
        else {
            throw new Error(`Invalid iconTag ${item.iconTag}`);
        }
    }
    else {
        return React.createElement("img", { className: "dpc-Waffle-row-logo", alt: "", src: item.icon });
    }
};
RowIcon.displayName = 'RowIcon';
